import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}
@Component({
  selector: "app-area-alert-list",
  templateUrl: "./area-alert-list.component.html",
  styleUrls: ["./area-alert-list.component.scss"],
})
export class AreaAlertListComponent implements OnInit {
  breadCrumbItems: Array<{}>;
  dtOptions: DataTables.Settings = {};
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtTrigger = new Subject<any>();
  UserID: any;
  Data: any;
  isLoading: boolean;
  user: any;
  planId: any;
  constructor(
    private router: Router,
    private renderer: Renderer2,
    private datepipe: DatePipe,
    private gs: GeneralService,
    private http: HttpClient
  ) {
    let a = this.router.getCurrentNavigation().extras;
    if (a) {
      if (a.state) {
        this.UserID = a.state.UserId;
        this.planId = a.state["PlanId"];
        console.log("thisuserid", this.UserID);
        localStorage.setItem("UserId", this.UserID);
        // localStorage.setItem("planId", this.planId);
      }
    }
    if (localStorage.getItem("UserId")) {
      this.UserID = localStorage.getItem("UserId");
    }
    this.breadCrumbItems = [
      { label: "User Details", path: "/users/users-users-details" },
      { label: "Area-Alert List", path: "/", active: true },
    ];
  }

  ngOnInit() {
    this.getusersbyid();
    this.dtOptions = {
      pagingType: "simple_numbers",
      pageLength: 10,
      processing: true,
      serverSide: true,
      ordering: false,
      searching: true,
      ajax: (dataTablesParameters: any, callback) => {
        // console.log("lin")
        this.http
          .get<DataTablesResponse>(
            // `${this.gs.getLawyer()}/${dataTablesParameters.search.value != '' ? dataTablesParameters.search.value + '/' : ''}${((dataTablesParameters.start + dataTablesParameters.length) / dataTablesParameters.length)}/${dataTablesParameters.length}`,

            `${this.gs.areaAlertList()}` +
              `?UserID=${this.UserID}` +
              `&pageNo=${
                (dataTablesParameters.start + dataTablesParameters.length) /
                dataTablesParameters.length
              }` +
              `${
                dataTablesParameters.length.value != ""
                  ? "&PageSize=" + dataTablesParameters.length
                  : ""
              }` +
              `${
                dataTablesParameters.search.value != ""
                  ? "&search=" + dataTablesParameters.search.value
                  : ""
              }`
          )
          .subscribe((resp: any) => {
            console.log("Area Alert", resp);
            callback({
              recordsTotal: resp.Count,
              recordsFiltered: resp.Count,
              data: resp.result,
            });
            console.log("Society List", resp.result);
          });
      },
      columns: [
        {
          title: "ID",
          data: null,
          render: (data) => {
            return data.id ? data.id : "--";
          },
        },
        {
          title: "Entry_Date",
          data: null,
          render: (data) => {
            if (data.entrydate === "0000-00-00" || data.entrydate == null) {
              return "--";
            } else {
              return this.datepipe.transform(data.entrydate, "yyyy-MM-dd");
            }
          },
        },
        {
          title: "VillageName",
          data: null,
          render: (data) => {
            return data.villagename ? data.villagename : "--";
          },
        },
        {
          title: "TalukaName",
          data: null,
          render: (data) => {
            return data.Talukaname ? data.Talukaname : "--";
          },
        },
        {
          title: "DistrictName",
          data: null,
          render: (data) => {
            return data.districtname ? data.districtname : "--";
          },
        },
        {
          title: "Action",
          name: "id",
          orderable: false,
          data: null,
          render(data) {
            return `<div style="display:flex" >
            <a class="btn text-primary edit" title="Edit Notice">
            <i class="btn font-18 mdi mdi-content-save-edit-outline text-secondary" UserId="${data.id}"></i></a>
            <a title="Delete Property"> <i style="display:flex;margin-top: 14px; cursor:pointer;font-size: 20px; color:#c20615"class="material-icons"  UserId="${data.id}">delete</i></a>
          `;
          },
        },
      ],
      drawCallback: () => {
        $(".edit").on("click", (e) => {
          this.router.navigate(
            [
              "users/users-users-details/addAreaAlert/edit/" +
                e.target.getAttribute("UserId"),
            ],
            {
              state: {
                id: e.target.getAttribute("UserId"),
                Editproperty: true,
                UserId: this.UserID,
                isEdit: true,
              },
            }
          );
        });
        // $('.delete').on('click', (e) => {
        // this.gs.deletePropertylist
        // });

        $(".material-icons").on("click", (e) => {
          console.log("218", e.target.getAttribute("UserId"));
          this.delete(e.target.getAttribute("UserId"));
        });
      },
    };
  }
  getusersbyid() {
    this.isLoading = true;
    this.gs.getusersbyid(this.UserID).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.user = res.data[0];
        this.user.mobileno = this.user.MobileNo.split(",");
        this.user.email = this.user.EmailID.split(",");
        localStorage.setItem("PlanID", this.planId);
      },
      (error) => {
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
      }
    );
  }
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
  areaAlert() {
    this.router.navigate(["users/users-users-details/addAreaAlert/"], {
      state: {
        UserId: this.UserID,
        Editproperty: false,
        isEdit: false,
        isLoading: false,
      },
    });
  }
  ngAfterViewInit() {
    this.dtTrigger.next();
    // this.UserID = this.UserID
  }
  delete(id) {
    console.log("262", id);
    this.isLoading = true;
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this Area-alert detail?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonClass: "btn btn-danger mt-2",
      cancelButtonClass: "btn btn-success ml-2 mt-2",
      buttonsStyling: false,
      showConfirmButton: true,
    }).then((result) => {
      if (result.value) {
        this.gs.deleteArealert(id).subscribe((res) => {
          console.log("Delete", res);
          Swal.fire({
            title: "Success",
            text: "Data Deleted successfully.",
            type: "success",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.rerender();
          });
          this.isLoading = false;
        });
      }
    });
  }
}
